import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import OpenAlexStats from "../views/OpenAlexStats.vue";

import Serp from "../views/Serp";
import EntityPage from "@/views/EntityPage.vue";
import store from "@/store";
import UserSignup from "@/components/user/UserSignup.vue";
import UserMagicToken from "../components/user/UserMagicToken.vue";
import Login from "@/views/Login.vue";
import Me from "../views/Me.vue"

import goTo from 'vuetify/es5/services/goto'
import OurStats from "../views/OurStats.vue";
import {entityTypeFromId, isOpenAlexId} from "@/util";
import PageNotFound from "@/views/PageNotFound.vue";
import Signup from "@/views/Signup.vue";
import SavedSearches from "@/views/SavedSearches.vue";
import {url} from "@/url";
import {getEntityConfigs} from "@/entityConfigs";


Vue.use(VueRouter)


// const entityNames = "works|authors|sources|publishers|funders|institutions|concepts"

const entityNames = getEntityConfigs().map(c => c.name).join("|")

const routes = [



    // data pages
    {
        path: `/:entityType(${entityNames})`,
        name: 'Serp',
        component: Serp,
    },

    {
        path: `/:entityId([waspfict]\\d+)`,
        name: 'EntityPageShortcut',
        redirect: to => {
            const entityType = entityTypeFromId(to.params.entityId)
            console.log("routes EntityPageShortcut", to.params)
            return {
                name: "EntityPage",
                params: {
                    entityType,
                    entityId: to.params.entityId,
                },
            }
        }
    },


    // user pages and routes
    {path: '/signup', name: 'Signup', component: Signup},
    {path: '/login', name: 'Login', component: Login},
    {path: '/me/searches', name: 'SavedSearches', component: SavedSearches, meta: {requiresAuth: true}},
    // {path: '/login/magic-token/:token', name: 'Magic-token', component: UserMagicToken},
    {path: '/me', name: 'Me', component: Me, meta: {requiresAuth: true}},


    // static pages
    {
        path: '/',
        // redirect: {name: "Serp", params: {entityType: "works"}},
        component: Home,
        name: 'Home',
        // component: Home
    },
    {path: '/stats', component: OurStats},

    {
        path: `/:entityType/:entityId`,
        name: 'EntityPage',
        component: EntityPage,
    },

    {path: '*', component: PageNotFound},


]

const router = new VueRouter({
    routes,
    mode: "history",
    scrollBehavior: (to, from, savedPosition) => {
        if (to.hash) {
            return goTo(to.hash, {
                offset: 75,
            })
        } else if (savedPosition) {
            return savedPosition
        } else if (to.name === "Serp") {
            // do nothing
        } else {
            return {x: 0, y: 0}
        }
    },
})

const redirectFromOldFilters = function (to, from, next) {
    const redirects = {
        // "institutions.country_code": "authorships.countries",
        // "topics.id": "primary_topic.id",
    }
    const isRedirectNeeded = Object.keys(redirects).some(key => {
        return to.name === "Serp" && to.fullPath.includes(key)
    })
    if (isRedirectNeeded) {
        let newFullPath = to.fullPath
        Object.keys(redirects).forEach(k => {
            newFullPath = newFullPath.replaceAll(k, redirects[k])
        })
        return next(newFullPath)
    }
}


router.beforeEach(async (to, from, next) => {
    if (localStorage.getItem("token") && !store.getters["user/userId"]) {
        try {
            await store.dispatch("user/fetchUser")
        } catch (e) {
            store.commit("user/logout")
        }
    }

    redirectFromOldFilters(to, from, next)

    if (to.matched.some(record => record.meta.requiresAuth)) {
        // this page requires authentication
        if (store.getters["user/userId"]) {  // you're logged in great. proceed.
            next()
        } else { // sorry, you can't view this page. go log in.
            next("/login")
        }
    } else { //  no auth required. proceed.
        next()
    }
});


export default router
